import React from 'react';
import { Reward } from 'entity/reward/rewardTypes';
import { claimRewardRequest } from 'entity/reward/rewardRedux';
import { useDispatch } from 'react-redux';
import Button from 'app/seedly-component-library/button-new';
import Dialog from 'app/seedly-component-library/dialog';

interface OwnProps {
  isOpen: boolean;
  setOpenConfirmationModal?: (params: boolean) => void;
  reward: Reward;
}

const ConfirmClaimRewardModal = (props: OwnProps) => {
  const { isOpen = false, setOpenConfirmationModal, reward } = props;

  const dispatch = useDispatch();

  if (!reward) return null;

  return (
    <Dialog
      isOpen={isOpen}
      headerTitle="Reward Redemption"
      onCloseClick={() => setOpenConfirmationModal(false)}
      isMobileFullHeight={false}
      widthSize="sm"
    >
      <p>
        You’re about to redeem <span className="font-bold">{reward.title}</span>{' '}
        with{' '}
        <span className="font-bold">
          {reward.minCredits?.toLocaleString()} credits
        </span>
        . Would you like to proceed?
      </p>
      <div className="flex justify-end w-full gap-2 items-center mt-2">
        <Button
          variant="outline"
          onClick={() => setOpenConfirmationModal(false)}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            dispatch(claimRewardRequest(reward.id));
            setOpenConfirmationModal(false);
          }}
        >
          Redeem
        </Button>
      </div>
    </Dialog>
  );
};

export default ConfirmClaimRewardModal;
